import { Flex, List, Modal, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

type RequirementsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  requiredStatementMonths: number;
};

export const RequirementsModal = ({ isOpen, onClose, requiredStatementMonths }: RequirementsModalProps) => {
  const intl = useIntl();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={intl.formatMessage(MESSAGES.requirementsModalTitle)} size="small">
      <Flex direction="column" gap="4">
        <Text textWrap="pretty">
          {intl.formatMessage(MESSAGES.requirementsModalBody, { requiredMonths: requiredStatementMonths })}
        </Text>
        <Flex direction="column" gap="2">
          <Text fontWeight="semiBold">{intl.formatMessage(MESSAGES.requirementsModalListHeading)}</Text>
          <List>
            <List.Item>{intl.formatMessage(MESSAGES.requirementsModalRuleGaps)}</List.Item>
            <List.Item>{intl.formatMessage(MESSAGES.requirementsModalRuleNoTransactions)}</List.Item>
          </List>
        </Flex>
        <Text color="subtle" size="sm">
          {intl.formatMessage(MESSAGES.requirementsModalFootnote)}
        </Text>
      </Flex>
    </Modal>
  );
};
